export default {
  evaluation_dashboard: {
    title: 'Dasbor Pembeli',
    unit: 'Perusahaan',
    average: 'Skor Rata-Rata:',
    point: 'poin',
    answered_label: 'Dikirim',
    evaluated_label: 'Dinilai',
    // corporate_average: "",
    points_earned_by_companies: 'Distribusi skor pemasok Anda',
    year_modal: {
      title: 'Pilih tahun',
      label: 'Tahun',
    },
    response_status_title: 'Distribusi status jawaban',
    response_status_rating_nothing: 'Belum ada jawaban',
    esg_rating_title: 'Distribusi peringkat ESG',
    esg_score_title: 'Distribusi Skor ESG',
    category_scores_title: 'Bandingkan skor berdasarkan kategori',
    category_scores_distribution_title: 'Distribusi skor berdasarkan kategori',
    category_score_data_all_label: 'Semua perusahaan yang dinilai oleh Asene ESG',
    esg_scores_by_industry_title: 'Distribusi skor ESG berdasarkan industri',
    environment_score_title: 'Distribusi skor lingkungan',
    social_score_title: 'Distribusi skor sosial',
    governance_score_title: 'Distribusi skor tata kelola',
    environment_score_subtitle_upper5: '5 Skor Lingkungan Teratas',
    environment_score_subtitle_lower5: '5 Skor Lingkungan Terburuk',
    social_score_subtitle_upper5: '5 Skor Sosial Teratas',
    social_score_subtitle_lower5: '5 Skor Sosial Terburuk',
    governance_score_subtitle_upper5: '5 Skor Tata Kelola Teratas',
    governance_score_subtitle_lower5: '5 Skor Tata Kelola Terburuk',
    // empty_error_message: "",
    common: {
      companies: 'Perusahaan',
      update_date: 'Tanggal terakhir diperbarui',
    },
    registration_rate: {
      title: 'Tingkat pendaftaran',
      tip: 'Perusahaan yang terdaftar di ASUENE ESG dari total jumlah perusahaan yang akan dinilai',
    },
    answer_rate: {
      title: 'Tingkat pengiriman',
      tip: 'Perusahaan yang mengirim survei dari total jumlah perusahaan yang akan dinilai',
    },
    days_remaining: {
      title: 'Jumlah hari hingga akhir survei',
      tip: 'Hari tersisa hingga batas waktu yang ditetapkan.\nSilakan hubungi kami jika Anda ingin mengubah tenggat.',
      days_remaining_before: 'Sisa',
      days_remaining_after: 'hari',
      expired: 'Telah lewat tenggat.',
    },
    answer_transition: {
      title: 'Tren pengiriman',
      companies_submitted: 'Perusahaan yang mengirim',
      breakdown: 'Perincian',
      unregistered: 'Tidak terdaftar',
      total: 'Total',
      number_of_companies: 'Jumlah perusahaan',
    },
    answer_list: {
      title: 'Pengiriman terbaru',
      submitted_at: 'Tanggal jawaban',
    },
  },
}
